import { render, staticRenderFns } from "./TakingAddForm.vue?vue&type=template&id=d6caa612"
import script from "./TakingAddForm.vue?vue&type=script&lang=js"
export * from "./TakingAddForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports